import * as Pickr from '@simonwep/pickr/dist/pickr.es5.min';
import { q, ww } from 'bobjoll/ts/library/dom';
import { Uicons } from 'Pods/uicons/index';

ww.Pickr = Pickr;

const setUiconColor = (toColor?: string): void => {
    let color = toColor || defaultColor;
    const uicon = document.querySelectorAll('.uicon-detail-holder svg [fill]');

    if (uicon) {
        uicon.forEach(el => el.setAttribute('fill', color));
    }
    getContrast(color);
};

const saveLastColor = (): void => {
    const svg = document.querySelector('.uicon-detail-holder')?.innerHTML;
    Uicons.svgCode = svg || '';

    const finalColor = document.querySelector('.uicon-detail-holder svg [fill]')?.getAttribute('fill');

    if (finalColor !== defaultColor) {
        Uicons.isEdited = true;
    }
};

const getContrast = (hexcolor: string): void => {
    if (hexcolor.slice(0, 1) === '#') {
        hexcolor = hexcolor.slice(1);
    }

    const r = parseInt(hexcolor.substring(0, 2), 16);
    const g = parseInt(hexcolor.substring(2, 4), 16);
    const b = parseInt(hexcolor.substring(4, 6), 16);

    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    const contrast = yiq >= 128 ? 'black' : 'white';

    const imageHolder = document.querySelector('.detail__top .detail__content') as HTMLElement;

    imageHolder.style.background = contrast === 'black' ? '#1D262D' : '#f8fafb';
};

let defaultColor = '#374957';

const pickrInit = (): void => {
    defaultColor = '#000000';

    const pickr = ww.Pickr.create({
        el: '#uicon-color-picker-wrapper',
        container: '.uicon-edit-color-picker',
        showAlways: false,
        inline: false,
        comparison: false,
        useAsButton: true,
        defaultRepresentation: 'HEX',
        default: defaultColor,
        swatches: [defaultColor],
        components: {
            preview: false,
            opacity: false,
            hue: true,
            interaction: {
                hex: false,
                rgba: false,
                hsla: false,
                hsva: false,
                cmyk: false,
                input: true,
                clear: false,
                save: false,
            },
        },
    });

    if (!pickr) {
        return;
    }

    const colorButton = q('.pcr-swatches button') as HTMLButtonElement;
    const inputColor = q('.pcr-result') as HTMLInputElement;

    pickr.on('change', (color: any) => {
        setUiconColor(
            color
                .toHEXA()
                .toString()
                .toLowerCase(),
        );

        colorButton.style.color = color.toHEXA().toString();
    });

    pickr.on('changestop', () => saveLastColor());

    if (colorButton) {
        colorButton.disabled = true;
    }

    if (inputColor) {
        inputColor?.setAttribute('maxlength', '7');
        inputColor.onblur = () => saveLastColor();
    }
};

export const ColorUicon = {
    pickrInit,
    setUiconColor,
};
